import React from "react";
interface UserLabel {
    name?: string | undefined,
    label: string | undefined,
    className?: string | undefined,
    required?: boolean,
    subLabel?: string | number,
}

const HTMLLabel = (props: UserLabel) => {
    const { name, label, className, required, subLabel } = props;
    return (
        <label id={name} className={className+ " html_label_content"}>
            {label && <span dangerouslySetInnerHTML={{ __html: label }}></span>}
            {subLabel ? <span className="sub-label">{subLabel}</span> : ""}
            {required ? <span className="star">{" "}*</span> : ""}
        </label>
    );
};

export default HTMLLabel;